import {
  fmtBingxSymbol,
  mapIntervalToBingx,
  decodeWsMessage,
  extractWsKline,
  randomId,
  normalizeCandleFlexible,
} from "./bingx/utils";

const API_HOST = "https://open-api.bingx.com";
const PROXY    = `${process.env.REACT_APP_BACKEND_URL}/proxy`;
const WS_URL   = "wss://open-api-swap.bingx.com/swap-market";

function viaProxy(absUrl) { return `${PROXY}/${encodeURI(absUrl)}`; }

/** REST история фьючерс-свечей */
export async function bingxFuturesFetchHistory({
  symbol,
  interval = "1m",
  limit = 500,
  startTime,
  endTime,
}) {
  const sym = fmtBingxSymbol(symbol);
  const tf  = mapIntervalToBingx(interval);

  const qs = new URLSearchParams();
  qs.set("symbol", sym);
  qs.set("interval", tf);
  if (limit)     qs.set("limit", String(limit));
  if (startTime) qs.set("startTime", String(startTime));
  if (endTime)   qs.set("endTime", String(endTime));
  qs.set("timestamp", String(Date.now()));

  const abs = `${API_HOST}/openApi/swap/v3/quote/klines?${qs.toString()}`;
  const url = viaProxy(abs);

  console.log("[bingxFut REST] fetch", { symbol: sym, interval: tf, limit, url });

  // const r = await fetch(url);
  const r = await fetch(url, {
    headers: {
      'ngrok-skip-browser-warning': 'true',
    },
  });
  const text = await r.text();
  let json = null; try { json = JSON.parse(text); } catch {}

  console.log("[bingxFut REST] http", {
    status: r.status, ok: r.ok, textLength: text?.length, parsed: !!json,
    code: json?.code, msg: json?.msg,
    dataType: Array.isArray(json?.data) ? "array" : typeof json?.data,
    sample0: Array.isArray(json?.data) && json.data.length ? json.data[0] : undefined,
  });
  if (!r.ok) throw new Error(`BingX FUTURES REST HTTP ${r.status}`);

  const rows = Array.isArray(json?.data) ? json.data : [];
  const out  = rows.map(normalizeCandleFlexible).filter(Boolean).sort((a,b)=>a.time-b.time);

  console.log("[bingxFut REST] done", {
    symbol: sym, interval: tf, rawCount: rows.length, normCount: out.length,
    first: out[0], last: out[out.length-1],
  });
  return out;
}

/** WS подписка на фьючерс-свечи */
export function bingxFuturesOpenWS({ symbol, interval = "1m", onBar }) {
  const sym = fmtBingxSymbol(symbol);
  const tf  = mapIntervalToBingx(interval);
  const ws  = new WebSocket(WS_URL);

  ws.onopen = () => {
    const sub = { id: randomId(), reqType: "sub", dataType: `${sym}@kline_${tf}` };
    ws.send(JSON.stringify(sub));
    console.log("[bingxFut WS] open&sub", sub);
  };

  ws.onmessage = async (evt) => {
    const msg = await decodeWsMessage(evt);
    console.log("[bingxFut WS] message", {
      kind: typeof msg,
      keys: msg && typeof msg === "object" ? Object.keys(msg) : null,
      preview: msg?.dataType || msg?.type || (typeof msg === "string" ? msg.slice(0,32) : undefined)
    });

    if (!msg) return;
    if (msg === "Ping" || msg?.ping) { try { ws.send("Pong"); } catch {} return; }

    const ext = extractWsKline(msg);
    if (!ext) return;

    if (Array.isArray(ext.candles) && ext.candles.length) {
      for (const c of ext.candles) { try { onBar?.(c); } catch {} }
    } else if (ext.candle) {
      try { onBar?.(ext.candle); } catch {}
    }
  };

  ws.onerror = (e) => { console.warn("[bingxFut WS] error", e); };
  ws.onclose = () =>   { console.log("[bingxFut WS] close"); };

  return () => { try { ws.close(1000, "bingxFut ws close"); } catch {} };
}
